<script>
  import { getContext } from 'svelte'

  // export let elementName
  // export let variant
  // export let config
  // export let id

  const subElement = getContext('currentSubElement')
</script>

<fieldset class="fieldset">
  {#if $subElement.label}
    <legend class="legend">{$subElement.label}</legend>
  {/if}
  <slot />
</fieldset>
